module.exports = __webpack_public_path__ + "img/fuelomat_inverzni_fit.4cddb9a5.svg";